import { useRef } from 'react';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import { toast } from 'sonner';
import { ACCEPT_ATTR, formatBytes, validarAnexo } from './anexoConstants';

interface PendingAnexosSectionProps {
  files: File[];
  onFilesChange: (files: File[]) => void;
}

// Seleção de anexos antes de a atividade existir no backend (sem atividadeId ainda para o upload real).
// Os arquivos ficam em memória e são enviados pelo chamador ao salvar a atividade.
export function PendingAnexosSection({ files, onFilesChange }: PendingAnexosSectionProps) {
  const inputRef = useRef<HTMLInputElement>(null);

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const selected = Array.from(e.target.files || []);
    e.target.value = '';
    if (selected.length === 0) return;

    const validos: File[] = [];
    for (const file of selected) {
      const erro = validarAnexo(file);
      if (erro) { toast.error(erro); continue; }
      validos.push(file);
    }
    if (validos.length > 0) onFilesChange([...files, ...validos]);
  };

  const handleRemove = (index: number) => {
    onFilesChange(files.filter((_, i) => i !== index));
  };

  return (
    <div className="space-y-2">
      <div className="flex items-center justify-between">
        <span className="text-sm font-medium text-muted-foreground">
          Anexos {files.length > 0 && <Badge variant="secondary" className="ml-1">{files.length}</Badge>}
        </span>
        <Button type="button" variant="outline" size="sm" onClick={() => inputRef.current?.click()}>
          + Adicionar arquivo
        </Button>
      </div>

      <input ref={inputRef} type="file" accept={ACCEPT_ATTR} multiple className="hidden" onChange={handleFileChange} />
      <p className="text-xs text-muted-foreground">PDF, imagem ou documento Office · máx. 10 MB</p>

      {files.length === 0 ? (
        <p className="text-xs text-muted-foreground py-1">
          Nenhum anexo selecionado. Os arquivos serão enviados ao salvar a atividade.
        </p>
      ) : (
        <ul className="space-y-1.5">
          {files.map((file, i) => (
            <li key={`${file.name}-${i}`} className="flex items-center gap-2 text-sm border rounded-md px-3 py-2 bg-muted/30">
              <span className="flex-1 truncate">{file.name}</span>
              <span className="text-xs text-muted-foreground shrink-0">{formatBytes(file.size)}</span>
              <Button
                type="button"
                variant="ghost"
                size="sm"
                className="h-6 px-2 text-xs text-destructive hover:text-destructive"
                onClick={() => handleRemove(i)}
              >
                Remover
              </Button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
